import gql from 'graphql-tag'
import { shiftTemplateFragment } from '@/graphql/shift/shiftFragments'

export const SHIFTTEMPLATES = gql`
    query shiftTemplates(
        $ids: [ID]
        $page: Int
        $first: Int
        $trashed: Trashed
    ){
        shiftTemplates(
            ids: $ids
            page: $page
            first: $first
            trashed: $trashed
        ){
            data{
                ...shiftTemplateFragment
            }
        }
    }
    ${ shiftTemplateFragment }
`
